export class Menu {
    public static leftMenusList = {
        candidate:
            {
                menuType: "menu",
                landingUrl: "/Dashboard",
                menusList:
                    [
                        { redirectTo: '/Dashboard/EXAMSTOSCHEDULE', text: 'Exams to Schedule', menuIconUrl: './assets/images/Artboard2.png', orderNo: 1 },
                        { redirectTo: '/Dashboard/SCHEDULED', text: 'Exams Scheduled', menuIconUrl: './assets/images/Artboard3.png', orderNo: 2 },
                        { redirectTo: '/Dashboard/COMPLETED', text: 'Exams Taken', menuIconUrl: './assets/images/Artboard10.png', orderNo: 5 },
                        { redirectTo: '/Dashboard/EXAMSEXPIRED', text: 'Exams Expired', menuIconUrl: './assets/images/Artboard12.png', orderNo: 6 },
                        { redirectTo: '/Dashboard/ALL', text: 'All Exams', menuIconUrl: './assets/images/Artboard14.png', orderNo: 7 }
                    ],
            },
        global_administrator:
            {
                menuType: "group",
                landingUrl: "/AdmManageLocation",
                groups:
                    [
                        {
                            type: 'group', redirectTo: '', groupText: 'Manage Locations', groupMenuIconUrl: './assets/images/manage-locations2.png', orderNo: 1,
                            menusList: [
                              { redirectTo: '/AdmManageLocation', text: 'Testing Centers', menuIconUrl: './assets/images/NoImg.png', orderNo: 1 },
                              { redirectTo: '/AdmManageCountry', text: 'Countries', menuIconUrl: './assets/images/NoImg.png', orderNo: 2 }
                            ]
                        },
                        {
                            type: 'group', redirectTo: '', groupText: 'Manage Administrators', groupMenuIconUrl: './assets/images/Manage-Admin.png', orderNo: 2,
                            menusList: [
                                { redirectTo: '/AdmManageSiteAdmin', text: 'Site Administrators', menuIconUrl: './assets/images/NoImg.png', orderNo: 1 },
                                { redirectTo: '/AdmManageRegionalAdmin', text: 'Regional Administrators', menuIconUrl: './assets/images/NoImg.png', orderNo: 2 },
                                { redirectTo: '/AdmManageGlobalAdmin', text: 'Global Administrators', menuIconUrl: './assets/images/NoImg.png', orderNo: 3 }
                            ]
                        },
                        {
                            type: 'menu', redirectTo: '/AdmManageEligibilities', groupText: 'Exam Deliveries', groupMenuIconUrl: './assets/images/Exam-deliveries.png', orderNo: 3,
                            menusList: []
                        },
                        {
                            type: 'group', redirectTo: '', groupText: 'Location Settings', groupMenuIconUrl: './assets/images/Location-csetting2.png', orderNo: 4,
                            menusList: [
                                { redirectTo: '/AdmManageLocationSetting', text: 'Location Settings', menuIconUrl: './assets/images/NoImg.png', orderNo: 1 },
                                { redirectTo: '/AdmNominateUsersLocationUpdates', text: 'Notification Accounts', menuIconUrl: './assets/images/NoImg.png', orderNo: 2 },
                            ]
                        },
                        {
                            type: 'menu', redirectTo: '/AdmExceptionCalendar', groupText: 'Exception Calendar', groupMenuIconUrl: './assets/images/Exception-Calendar.png', orderNo: 5,
                            menusList: []
                        },
                        {
                            type: 'group', redirectTo: '', groupText: 'Manage Policies', groupMenuIconUrl: './assets/images/Manage-Policies.png', orderNo: 5,
                            menusList: [
                                { redirectTo: '/AdmManageUniversalOperationalHours', text: 'Hours of Operation', menuIconUrl: './assets/images/NoImg.png', orderNo: 1 },
                                { redirectTo: '/AdmManageConcurrentExams', text: 'Concurrent Exams', menuIconUrl: './assets/images/NoImg.png', orderNo: 2 },
                                { redirectTo: '/AdmManageProctorAlertConfig', text: 'Proctor Alert Configuration', menuIconUrl: './assets/images/NoImg.png', orderNo: 3 },
                                { redirectTo: '/AdmManageChatIdleTime', text: 'Chat Idle Time', menuIconUrl: './assets/images/idle.png', orderNo: 4 }
                            ]
                        },
                        {
                            type: 'group', redirectTo: '', groupText: 'Proctoring Management', groupMenuIconUrl: './assets/images/Proctoring-Management.png', orderNo: 6,
                            menusList: [
                                { redirectTo: '/AdmManageProctorTeamLead', text: 'Manage Proctors', menuIconUrl: './assets/images/NoImg.png', orderNo: 1 },
                                { redirectTo: '/AdmManageOffice', text: 'Manage Offices', menuIconUrl: './assets/images/NoImg.png', orderNo: 3 }
                            ]
                        },
                        {
                            type: 'menu', redirectTo: '/EligibilityMessages', groupText: 'Eligibility Messages', groupMenuIconUrl: './assets/images/messages.png', orderNo: 7,
                            menusList: []
                        },

                    ],
            },
        site_administrator:
            {
                menuType: "group",
                landingUrl: "/AdmManageLocationSetting",
                groups:
                    [
                        {
                            type: 'group', redirectTo: '', groupText: 'Location Settings', groupMenuIconUrl: './assets/images/Location-csetting2.png', orderNo: 1,
                            menusList: [
                                { redirectTo: '/AdmManageLocationSetting', text: 'Location Settings', menuIconUrl: './assets/images/NoImg.png', orderNo: 1 },
                                { redirectTo: '/AdmNominateUsersLocationUpdates', text: 'Notification Accounts', menuIconUrl: './assets/images/NoImg.png', orderNo: 2 }
                            ]
                        },
                        {
                            type: 'menu', redirectTo: '/AdmExceptionCalendar', groupText: 'Exception Calendar', groupMenuIconUrl: './assets/images/Exception-Calendar.png', orderNo: 2,
                            menusList: []
                        },
                        {
                            type: 'menu', redirectTo: '/AdmManageEligibilities', groupText: 'Exam Deliveries', groupMenuIconUrl: './assets/images/Schedule.png', orderNo: 3,
                            menusList: []
                        }
                    ],
            },
        regional_administrator:
            {
                menuType: "group",
                landingUrl: "/AdmManageLocation",
                groups:
                    [
                        {
                            type: 'menu', redirectTo: '/AdmManageLocation', groupText: 'Manage Locations', groupMenuIconUrl: './assets/images/manage-locations2.png', orderNo: 1,
                            menusList: []
                        },
                        {
                            type: 'group', redirectTo: '', groupText: 'Manage Administrators', groupMenuIconUrl: './assets/images/Manage-Admin.png', orderNo: 2,
                            menusList: [
                                { redirectTo: '/AdmManageSiteAdmin', text: 'Site Administrators', menuIconUrl: './assets/images/NoImg.png', orderNo: 1 },
                            ]
                        },
                        {
                            type: 'menu', redirectTo: '/AdmManageEligibilities', groupText: 'Exam Deliveries', groupMenuIconUrl: './assets/images/Exam-deliveries.png', orderNo: 3,
                            menusList: []
                        },
                        {
                            type: 'group', redirectTo: '', groupText: 'Location Settings', groupMenuIconUrl: './assets/images/Location-csetting2.png', orderNo: 4,
                            menusList: [
                                { redirectTo: '/AdmManageLocationSetting', text: 'Location Settings', menuIconUrl: './assets/images/NoImg.png', orderNo: 1 },
                                { redirectTo: '/AdmNominateUsersLocationUpdates', text: 'Notification Accounts', menuIconUrl: './assets/images/NoImg.png', orderNo: 2 },
                            ]
                        },
                        {
                            type: 'menu', redirectTo: '/AdmExceptionCalendar', groupText: 'Exception Calendar', groupMenuIconUrl: './assets/images/Exception-Calendar.png', orderNo: 5,
                            menusList: []
                        }
                    ],
            },
        proctorlead: // This is PROCTOR Role with isProctorLead : true
            {
                menuType: "group",
                landingUrl: "AdmManageProctors",
                groups:
                    [
                        {
                            type: 'menu', redirectTo: '/AdmManageProctors', groupText: 'Manage Proctors', groupMenuIconUrl: './assets/images/Proctoring-Management.png', orderNo: 1,
                            menusList: []
                        },
                        {
                            type: 'menu', redirectTo: '/AdmManageEligibilities', groupText: 'Exam Deliveries', groupMenuIconUrl: './assets/images/Exam-deliveries.png', orderNo: 2,
                            menusList: []
                        },
                    ],
            },
        proctor: // This is PROCTOR Role with isProctorLead : false
            {
                menuType: "group",
                landingUrl: "AdmManageEligibilities",
                groups:
                    [
                        {
                            type: 'menu', redirectTo: '/AdmManageEligibilities', groupText: 'Exam Deliveries', groupMenuIconUrl: './assets/images/Exam-deliveries.png', orderNo: 2,
                            menusList: []
                        }
                    ],
            },
        publicLocations: // the public
            {
              menuType: "menu",
              landingUrl: "/PublicLocations",
              menusList:
                  [
                    {redirectTo: "https://www.redhat.com/en/services/training/all-courses-exams/?f%5B0%5D=taxonomy_training%3AExam", text: "Ready to test?",},
                    {redirectTo: "https://www.redhat.com/en/services/training/all-courses-exams", text: "Need to train first?",},
                  ]
            },
    };
    //end leftMenusList
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/utility/menu.ts